import { useState } from 'react'

export default ({initialValue, maxValue}) => {
  const [activeValue, setActiveValue] = useState(initialValue)

  function setValue(e){
    setActiveValue(e)
  }

  function setNext(){
    if(activeValue < maxValue -1){
      setActiveValue(activeValue + 1)
      return
    }
  }
  function setPre(){
    if(activeValue > 0){
      setActiveValue(activeValue - 1)
    }
  }
  function onCancel(){
    setActiveValue(null)
  }

  return {
    activeValue,
    setNext,
    setPre,
    setValue,
    onCancel,
  }   
}